module.exports = __webpack_public_path__ + "img/credit_2.083ff58b.jpg";